module.exports = "/365FarmNet/dist/stockReport.3ca8a6d358fcc9fb1ec52a79f88ab898.html";